import {
    Action,
    combineReducers,
    configureStore,
    ThunkAction
} from '@reduxjs/toolkit';
import authReducer from './authSlice';
import calendarReducer from './calendarSlice';
import userSettingsReducer from './userSlice';
import configReducer from './configSlice';
import menuReducer from './menuSlice';
import bookingReducer from './bookingSlice';
import commonReducer from './commonSlice';
import { kitchenApi } from '../api/kitchenApi';
import '../api/menuApi';
import '../api/registryApi';
import '../api/bookingApi';
import '../api/userApi';
import '../api/ordersApi';

const rootReducer = combineReducers({
    auth: authReducer,
    sidebar: calendarReducer,
    userSettings: userSettingsReducer,
    config: configReducer,
    menu: menuReducer,
    booking: bookingReducer,
    common: commonReducer,
    [kitchenApi.reducerPath]: kitchenApi.reducer
});

export type RootState = ReturnType<typeof rootReducer>;

export function setupStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActionsPaths: ['meta.arg', 'payload.timestamp'],
                    ignoredPaths: [
                        'kitchenApi',
                        'userSettings.temporaryUser',
                        'common.error'
                    ]
                }
            }).concat(kitchenApi.middleware),
        preloadedState
    });
}

export const store = setupStore();

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
